import React from 'react';
import dataprivacyGraphic from './circle.png';
import dataImage from './d-2.png';

const Dataprivacy = () => {
  return (
    <section
    id="dataprivacy"
    className="bg-[#062B37] text-white scroll-mt-16 py-16 px-6 sm:px-8 lg:px-16 flex items-center"
  >
      <div className="flex flex-col justify-between items-center text-center max-w-7xl mb-10 mx-auto">
        <h2 className="text-3xl font-bold text-center mb-6">Data Privacy</h2>

        {/* ✅ Desktop only */}
        <div className="hidden lg:block">
          <div className="relative w-full max-w-[500px] aspect-square flex justify-center mb-6 mx-auto">
            <img
              src={dataprivacyGraphic}
              alt="Data Privacy Diagram"
              className="w-3/4 h-full object-contain"
            />
            <div className="absolute top-[8%] left-[-20%] text-left max-w-[140px] text-xs md:text-sm">
              <p className="font-bold text-xl whitespace-nowrap">Secure Storage</p>
              <p className="text-base">365-day secure document retention</p>
            </div>
            <div className="absolute top-[8%] right-[-10%] text-right max-w-[140px] text-xs md:text-sm">
            <p className="font-bold text-xl whitespace-nowrap">Authorized Access</p>
              <p className="text-base ">Strict permission control</p>
            </div>
            <div className="absolute bottom-[18%] left-[-20%] text-left max-w-[140px] text-xs md:text-sm">
            <p className="font-bold text-xl whitespace-nowrap">Expert Handling</p>
              <p className="text-base">Trained professionals</p>
            </div>
            <div className="absolute bottom-[18%] right-[-14%] text-right max-w-[140px] text-xs md:text-sm">
            <p className="font-bold text-xl whitespace-nowrap">Confidentiality</p>
              <p className="text-base">Analysts bound by legal agreements</p>
            </div>
          </div>

          <div className="text-center mt-4 max-w-3xl pr-2 mb-6">
            <p className="leading-relaxed text-xl text-justify">
              All uploaded documents are stored securely for 365 days and are only accessible to
              authorized analysts under strict confidentiality agreements. The platform is built with
              access controls and data privacy protocols to ensure security at every level of the ESG
              assessment process.
            </p>
          </div>
        </div>

        {/* ✅ Tablet only */}
        <div className="hidden sm:block lg:hidden">
          <div className="relative w-full max-w-[450px] h-[300px] mb-6 mx-auto">
            <img
              src={dataImage}
              alt="Data Privacy Tablet Diagram"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="text-center mt-4 max-w-3xl px-2 mb-6">
            <p className="leading-relaxed text-lg text-justify">
              All uploaded documents are stored securely for 365 days and are only accessible to
              authorized analysts under strict confidentiality agreements. The platform is built with
              access controls and data privacy protocols to ensure security at every level of the ESG
              assessment process.
            </p>
          </div>
        </div>

        {/* ✅ Mobile only */}
        <div className="block sm:hidden">
          <div className="relative w-full  max-w-[350px] aspect-square mb-6 mx-auto">
            <img
              src={dataImage}
              alt="Data Privacy Mobile Diagram"
              className="w-full h-full object-contain"
            />
          </div>
          <div className="text-center mt-4 max-w-3xl px-2 mb-6">
            <p className="leading-relaxed text-lg text-justify">
              All uploaded documents are stored securely for 365 days and are only accessible to
              authorized analysts under strict confidentiality agreements. The platform is built with
              access controls and data privacy protocols to ensure security at every level of the ESG
              assessment process.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Dataprivacy;
